<template>
	<v-container class="pa-4">
		<p class="display-1" align="center" justify="center">
			{{ $t("title.outlets") }}
		</p>
		<v-row class="fill-height" align="center" justify="center">
			<template v-for="(item, i) in outlets">
				<v-col :key="i" cols="12" sm="6" md="3">
					<v-card max-width="auto" tile>
						<v-img
							:src="
								item && item.image_url
									? item.image_url
									: image_placeholder
							"
							height="200px"
						>
							<v-app-bar flat color="rgba(0, 0, 0, 0)">
								<v-spacer></v-spacer>

								<v-btn
									class="mx-2"
									fab
									dark
									small
									color="white"
								>
									<v-icon size="20" color="black">
										mdi-heart-outline
									</v-icon>
								</v-btn>
							</v-app-bar>
						</v-img>
						<v-card-title primary-title>
							{{ item.outlet_name }}
						</v-card-title>
						<v-card-subtitle>
							<span
								class="d-inline-block text-truncate"
								style="max-width: 250px"
								>{{ item.address }}</span
							>
						</v-card-subtitle>
					</v-card>
				</v-col>
			</template>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		props: ["outlets", "image_placeholder"],
		data() {
			return {
				rating: 4.3,
			};
		},
	};
</script>